import { useState } from 'react'

/** Compact text field for paired size inputs (no label — used inside grid layouts) */
export function CompactTextField({
  value,
  onChange,
  placeholder,
}: {
  value: string
  onChange: (value: string) => void
  placeholder?: string
}) {
  const [draft, setDraft] = useState(value)
  const [focused, setFocused] = useState(false)

  if (!focused && draft !== value) {
    setDraft(value)
  }

  return (
    <input
      className="w-full h-6 bg-transparent border border-transparent rounded px-1.5 text-xs text-right hover:border-input focus:border-input focus:bg-muted/70 focus:outline-none focus:ring-1 focus:ring-ring transition-colors"
      value={draft}
      onChange={(e) => setDraft(e.target.value)}
      onFocus={() => setFocused(true)}
      onBlur={() => {
        setFocused(false)
        if (draft !== value) onChange(draft)
      }}
      onKeyDown={(e) => {
        if (e.key === 'Enter') {
          e.preventDefault()
            ; (e.target as HTMLElement).blur()
        }
        if (e.key === 'Escape') {
          setDraft(value)
            ; (e.target as HTMLElement).blur()
        }
      }}
      placeholder={placeholder}
    />
  )
}
